// @ts-nocheck
import { applySnapshot, cast, flow, getEnv, types } from "mobx-state-tree";
import { transformInput } from "./utils/misc";
import { filterBookings } from "./utils/filterBookings";
import RequestFlowStore from "./requestFlow";
import LocationFieldStore from "../location";
import ScheduleStore from "../schedule";
import TutorSubjectStore from "./tutorSubject";
import { PersonalInfoStore, defaultPersonalInfo } from "../personal-info";

export const TutorJobListStore:any = types
  .model("TutorJobList", {
    personalInfo: types.optional(PersonalInfoStore, defaultPersonalInfo),
    requests: types.optional(types.array(RequestFlowStore), []),
    currentIndex: types.optional(types.number, -1),
    locationInfo: types.optional(LocationFieldStore, {}),
    availability: types.optional(ScheduleStore, {}),
    subject: types.optional(TutorSubjectStore, {}),
    isLoggedIn: types.optional(types.boolean, false),
    appLoading: types.optional(types.boolean, false),
    appError: types.optional(types.boolean, false),
    bookingFilter: types.optional(types.string, "active"),
    currentPage: types.optional(types.string, ""),
  })
  .views((self) => {
    const { adapter } = getEnv(self);
    return {
      get shortInfo() {
        return {
          name: self.personalInfo.firstName,
          email: self.personalInfo.email,
        };
      },
      get currentRequest() {
        return self.requests[self.currentIndex];
      },
      get isSubmitting() {
        return this.currentRequest?.serverInfo.loading || false;
      },
      get requestData() {
        return self.requests.map((o) => o.requestData);
      },
      get tutorInfo() {
        const info = adapter.decodedToken("");
        return info;
      },
      get summaryInfo() {
        return self.requests.map((o) => o.jobInfo);
      },
      get bookings() {
        return filterBookings(self.bookingFilter, self.requests);
      },
    };
  })
  .actions((self) => {
    const { adapter } = getEnv(self);
    const initializeStore = flow(function* initialize(slug) {
      try {
        let jobs = yield adapter.fetchJobLists(slug);
        bulkMapToStore(jobs);
      } catch (error) {
        throw error;
      }
    });
    const savePersonalInfo = flow(function* savePersonalInfo(personalInfo) {
      try {
        let response = yield adapter.savePersonalInfo(personalInfo);
        return response;
      } catch (error) {
        throw error;
      }
    });
    function bulkMapToStore(arrayOfRequestData) {
      let arrayObj = arrayOfRequestData.map((rawData) => {
        let {
          contactDetails = {},
          lessonDetails = {},
          childDetails = [],
          filters = {},
          slug = "",
          tutor_info = {},
          paymentInfo,
          status,
          created,
          agent,
          bookingStage = {},
          tutorResponse,
        } = rawData;
        return {
          lessonLocationStore: {
            lessonType: lessonDetails.lessonType,
            country: contactDetails.country,
            state: contactDetails.state,
            region: contactDetails.region,
            address: contactDetails.address,
            vicinity: contactDetails.vicinity,
          },
          lessonScheduleStore: {
            ...lessonDetails.lessonSchedule,
          },
          teacherSelectStore: {
            teacherOption: rawData.teacherKind,
          },
          childStore: {
            childDetails: transformInput(childDetails).childDetails,
          },
          contactInfoStore: contactDetails,
          filterStore: filters,
          slug,
          serverInfo: {
            created,
            status,
            agent,
            tutorResponseInfo: tutorResponse,
            // bookingStage: bookingStage,
            tutorRequestInfo: {
              ...tutor_info,
              tutorData: paymentInfo?.tutor?.tutor || paymentInfo.tutor,
              rawPaymentInfo: paymentInfo?.tutor?.tutor
                ? paymentInfo.tutor
                : paymentInfo,
            },
          },
        };
      });
      self.requests = cast(arrayObj);
    }
    const updateJobStatus = flow(function* acceptJob(response, actionType) {
      yield self.currentRequest.serverInfo.updateJobStatus(
        response,
        actionType,
      );
    });
    const updateLoggedIn = (value) => (self.isLoggedIn = value);
    const updateAvailability = (availability = {}) => {
      applySnapshot(self.availability, availability);
    };
    const updatePreferredLessonType = (onlineProfile: any = {}) => {
      if (onlineProfile.acceptsOnline) {
        applySnapshot(self.availability.preferredLessonType, [
          "physical",
          "online",
        ]);
      } else {
        applySnapshot(self.availability.preferredLessonType, ["physical"]);
      }
    };

    const updateLocationInfo = (locationInfo = {}) => {
      applySnapshot(self.locationInfo, locationInfo);
    };
    const updateLoggedInStatus = flow(function* updateLoggedInStatus() {
      let isLoggedIn = yield adapter.checkIfLoggedIn();
      updateLoggedIn(isLoggedIn);
    });
    const onLogin = flow(function* onLogin(values: any) {
      // check if otp key exists in value and handle login based on that condition
      try {
        self.appError = false;
        self.appLoading = true;
        let userInfo = yield adapter.loginTutor(values);
        updateLoggedIn(true);
        self.appLoading = false;
        self.personalInfo = PersonalInfoStore.create({ ...userInfo });
      } catch (error) {
        self.appError = true;
        self.appLoading = false;
        console.log(error);
        throw error;
      }
    });

    const onSendEmail = flow(function* onSendEmail(values: any) {
      yield adapter.sendLoginCode(values);
    });

    return {
      updateLoggedInStatus,
      initializeStore,
      bulkMapToStore,
      updateAvailability,
      updateLocationInfo,
      savePersonalInfo,
      updatePreferredLessonType,
      setCurrentRequest(slug) {
        let booking = self.requests.findIndex(
          (booking) => booking.slug === slug,
        );
        if (booking > -1) {
          self.currentIndex = booking;
        }
      },

      initializeSchedule({
        availability = {},
        locationInfo = {},
        onlineProfile = {},
      }) {
        updateAvailability(availability);
        updateLocationInfo(locationInfo);
        updatePreferredLessonType(onlineProfile);
      },
      setVicinity(value) {
        self.locationInfo.vicinity = value;
      },
      setAddress(value) {
        self.locationInfo.address = value;
      },
      updateBookingFilter(filter) {
        self.bookingFilter = filter;
      },
      setCurrentPage(name: string) {
        self.currentPage = name;
      },
      updateJobStatus,
      updateLoggedIn,
      onLogin,
      onSendEmail,
    };
  });
